<template>
	<div class="loading">
		<div :class="classes"></div>
	</div>
</template>

<script>
export default {
	name: 'loading',
	props: {
		color: {
			type: String,
			default: 'blue'
		}
	},
	computed: {
		classes() {
			return `spinner spinner--${this.color}`
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/layout';
@import '~scss/components';

.loading {
	@extend %flex-center;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.spinner {
	$size: 3rem;

	&--blue {
		@include spinner($size);
	}
	&--white {
		@include spinner(3rem, $white);
	}
}
</style>
